<template>
  <v-select
    :items="certTypeOptions"
    :loading="loading"
    label="Certificate Type"
    item-text="value"
    item-value="valueid"
    @input="$emit('input', $event)"
    :value="value"
    v-bind="$attrs"
  />
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "certTypeSelect",
  data() {
    return {
      certTypeOptions: [],
      loading: false
    };
  },
  created() {
    this.loadCertTypes();
  },
  methods: {
    loadCertTypes() {
      this.loading = true;
      this.certTypeOptions = this.lookup("PracticingCertificateType");
      this.loading = false;
      // var reqs = [];

      // reqs.push(
      //   this.$http
      //     .get("/practicingcertificateTypes", {})
      //     .then(response => {
      //       this.loading = false;
      //       this.certTypeOptions = response.data;
      //     })
      //     .catch(e => {
      //       this.loading = false;
      //       this.handleError(e);
      //     })
      // );
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  computed: {
    ...mapGetters({ lookup: "lookup" })
  },
  props: {
    value: [Number, String]
  }
};
</script>
